import { render, staticRenderFns } from "./WaitingForParts.vue?vue&type=template&id=3d06c361&"
import script from "./WaitingForParts.vue?vue&type=script&lang=js&"
export * from "./WaitingForParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports